import { apiSlice } from './apiSlice';

const api = apiSlice.injectEndpoints({
  endpoints: builder => ({
    saveWikiGlossary: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-glossary/`,
          method: 'POST',
          body: arg,
        };
      },
      invalidatesTags: ['wikiGlossary'],
    }),
    getWikiGlossary: builder.query({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-glossary/?search=${arg}`,
          method: 'GET',
        };
      },
      providesTags: ['wikiGlossary'],
    }),
    deleteWikiGlossaryImage: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-glossary/${arg.itemId}/delete-image/${arg.id}/`,
          method: 'DELETE',
        };
      },
      invalidatesTags: ['wikiGlossary'],
    }),
    updateGlossary: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-glossary/${arg.id}/`,
          method: 'PATCH',
          body: arg.form,
        };
      },
      invalidatesTags: ['wikiGlossary'],
    }),
    deleteGlossaryRecord: builder.mutation({
      query: arg => {
        return {
          url: `wiki/wiki-jurisdiction-glossary/${arg.id}/`,
          method: 'DELETE',
          body: arg.form,
        };
      },
      invalidatesTags: ['wikiGlossary'],
    }),

  }),
});

export const {
  useSaveWikiGlossaryMutation,
  useGetWikiGlossaryQuery,
  useDeleteWikiGlossaryImageMutation,
  useUpdateGlossaryMutation,
  useDeleteGlossaryRecordMutation,
} = api;
